import { render } from "./SkeletonTable.vue?vue&type=template&id=731a6b5e&scoped=true"
import script from "./SkeletonTable.vue?vue&type=script&lang=js"
export * from "./SkeletonTable.vue?vue&type=script&lang=js"

import "./SkeletonTable.vue?vue&type=style&index=0&id=731a6b5e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-731a6b5e"],['__file',"src/common/components/BaseTable/SkeletonTable.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "731a6b5e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('731a6b5e', __exports__)) {
    api.reload('731a6b5e', __exports__)
  }
  
  module.hot.accept("./SkeletonTable.vue?vue&type=template&id=731a6b5e&scoped=true", () => {
    api.rerender('731a6b5e', render)
  })

}


export default __exports__